import { render, staticRenderFns } from "./libraryDownParams.vue?vue&type=template&id=1d13b56b&scoped=true"
import script from "./libraryDownParams.vue?vue&type=script&lang=js"
export * from "./libraryDownParams.vue?vue&type=script&lang=js"
import style0 from "./libraryDownParams.vue?vue&type=style&index=0&id=1d13b56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13b56b",
  null
  
)

export default component.exports